import styled from "styled-components";

export const Section = styled.section`
    margin: 5rem 0 5rem 0;
`;

export const TitleDiv = styled.div`
    display: flex;
    justify-content: center;
    margin: 1.56rem 0 1.56rem 0;
`;

export const Title = styled.h1`
    font-size: 1.25rem;
    color: #FFFFFF;
    font-weight: bold;

    @media (max-width: 425px) {
        font-size: 1rem;
    }
`;

export const SummaryDiv = styled.div`
    margin-top: 3.43rem;
`;

export const Paragraph = styled.p`
    margin: 0.62rem;
    font-size: 1.18rem;
    color: #FFFFFF;

    @media (max-width: 425px) {
        font-size: 1rem;
    }
`;